import React from 'react';
import { GlobalStyles } from '@spotify-internal/creator-tape';
import { Provider } from 'react-redux';
import { configureStore } from '../shared/store';
import { ActionPanelState } from '../features/ActionPanel';
import { SidePanelState } from '../features/SidePanel';
import { BannerState } from '../features/Banner';
import Viewport from '../shared/components/Viewport';
import { AppErrorBoundary } from './AppErrorBoundary';
import { AppSuspense } from './AppSuspense';
import { AppPage } from './AppPage';

const defaultStore = configureStore();

// prevents rerenders of globalStyles which sometimes flashes things
const globalStyles = <GlobalStyles noFonts />;

export function App({ store = defaultStore }: any) {
  return (
    <>
      {globalStyles}
      <AppErrorBoundary>
        <AppSuspense>
          <Provider store={store}>
            <Viewport>
              <SidePanelState>
                <ActionPanelState>
                  <BannerState>
                    <AppPage />
                  </BannerState>
                </ActionPanelState>
              </SidePanelState>
            </Viewport>
          </Provider>
        </AppSuspense>
      </AppErrorBoundary>
    </>
  );
}
